<!--begin header -->
<header class="header">
  <app-header></app-header>
</header>
<!--end header -->

<!-- actual content start-->

<!--begin container -->
<section style="padding-top: 115px;">

  <div class="container">
    <div class="row ">
      <div class="col-md-6">
        <h1 class="text-orange">Our People</h1>
      </div>
      <div class="col-md-6"></div>

    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/rsz_atul.jpg"
          alt="SingX CEO - Atul Garg - Remittance Company">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">Atul Garg- Principal Founder & CEO​</h3>
        <p class="mt-h">Atul has over 25 years of banking and payments experience with Bank of America and American Express. He is a
          Post Graduate Diploma in Business Management from the Indian Institute of Management, Ahmedabad and a
          Mechanical Engineer from Birla Institute of Technology & Science, Pilani , India. His general management and
          leadership qualities were sharpened while leading the network business for American Express in Korea, Indian
          Sub-Continent and ASEAN. His track record of growing market share in both developed and developing economies
          across Asia will be instrumental in his vision of introducing SingX to the world.</p>
      </div>
    </div>
    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/Deepika.jpg"
          alt="SingX COO - Deepika Deshpande - Money Transfer Overseas Company">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">Deepika Deshpande- Chief Operating Officer</h3>
        <p class="mt-h">Deepika is a financial services industry professional with 26 years of experience at Citibank followed by an
          assignment at a Singapore-based fintech where she served as Chief Operating Officer. Her career at Citi
          spanned multiple geographies and senior leadership roles in the Commercial Banking and risk and regulatory
          domains. She is currently pursuing a PhD at SMU. Deepika is an avid reader and enjoys writing on topics
          related to economics, finance, regulation, risk management and sustainability. She is an alumnus of the Indian
          Institute of Management, Ahmedabad (IIMA, PGP’93), and has a Bachelor of Arts (Economics) degree from Bombay
          University</p>
      </div>
    </div>

    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="./assets/images/SanjivMalhotra.png"
          alt="'Consumer Banking and Payments' business leader - Sanjiv Malhotra - International Payment Company">
      </div>
      <div class="col-md-8">
        <h3 class="mt-p teams">Sanjiv Malhotra - 'Consumer Banking and Payments' Business Leader​</h3>
        <p class="mt-h">Sanjiv is a 'Consumer Banking and Payments' business leader. Before joining SingX, he was the Vice President and General Manager for Southeast Asia & South Pacific of the Global Network Business of American Express. In this role he managed the American Express B2B payment/network business, bringing in and managing large bank partners in countries as diverse as Singapore, Hong Kong, Malaysia, Indonesia, Philippines, Vietnam, Thailand, Cambodia, Laos, French Polynesia etc. He is an associate member of the Institute of Chartered Accountants of India.</p>
      </div>
    </div>

    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="./assets/images/Rajkumar Photo 2 - No bg.jpg"
          alt="SingX Chief Technology Officer - Rajkumar Muthuswami">
      </div>
      <div class="col-md-8">
        <h3 class="mt-p teams">Rajkumar Muthuswami- Chief Technology Officer</h3>
        <p class="mt-h">Rajkumar brings over 25 years of experience in technology, spanning multiple domains. He has played a key role in designing and implementing cutting-edge technology systems for leading institutions, including Standard Chartered Bank, Crimson Logic and Emerio Technologies.
          With a strong foundation in Mechanical Engineering, Rajkumar holds multiple industry-recognized certifications, including PMI-PMP, Technical Architect, ITIL Expert, PRINCE2 Certified Practitioner, and Certified Scrum Master. His expertise in technology strategy, system architecture, and project management enables him to drive innovation and deliver impactful solutions.</p>
      </div>
    </div>


    

    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/Scott.png"
          alt="SingX Hong Kong Representative - Scott Dale -International Money Transfer">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">Scott Dale- Hong Kong Representative</h3>
        <p>Scott Dale is a seasoned General Manager in the financial services, travel and lifestyle industries with an
          expertise in working effectively in Asia. Scott's unique and diverse skill set have been developed through
          more than 25 years of work experience, with 18 years spent at leading travel and financial services company,
          American Express Int'l Inc. Having lived in Asia since 2002, Scott has led and been involved in multiple
          business transformational initiatives and new launches / implementations of product, sales and servicing
          models, whilst balancing the need for continuity within the existing business. Excellent outcomes were
          achieved through his excellent leadership and communication qualities. Away from the office Scott is an avid
          and lifelong sportsman and is still actively engaged in both rugby union and paddling sports. Scott currently serves as the MLRO for SingX Singapore and SingX Hong Kong</p>
      </div>
    </div>

    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/Tony.png"
         alt="SingX Australia Representative - Tony Leung - International Fund Transfer">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">Tony Leung- Australia Representative</h3>
        <p class="mt-h">Tony is a professional with over 30 years of experience in management roles in the financial services
          industry across Asia Pacific. He was a Director at American Express and responsible for partner servicing and
          business development. He has an extensive background in mobile payments and e-commerce technologies deployment
          with strong exposure in the payments industry and branded consumer products. He holds a Bachelor of Science
          (Mathematics) degree from the University of Hong Kong. Tony currently serves as the MLRO for SingX Australia. </p>
      </div>
    </div>
    
    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/Sree.png" 
        alt="SingX Head of Digital Marketing - SreeKrishnaa Srikanthan -Send Money Internationally">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">SreeKrishnaa Srikanthan – Head of Digital Marketing</h3>
        <p class="mt-h">Sreekrishnaa has over 10 years of experience spanning across technology, digital and financial services
          industries. Sreekrishnaa started his career with Infosys as a technology consultant, spearheading several
          process improvement initiatives. As the Head of Operations at Art of Click, he has a solid track record of
          promoting brands and transforming start-up businesses with innovative digital marketing strategies.
          Sreekrishnaa is a Dean’s list Business Management graduate with a specialization in Financial Services from
          Singapore Management University and has a bachelor's degree in Electronics from Sastra University, India.</p>
      </div>
    </div>

    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/Shefali.png"
          alt="SingX Head of Marketing - Shefali Garg -Transfer Money Internationally">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">Shefali Garg- Head of Marketing</h3>
        <p class="mt-h">Shefali has over 12 years of experience in banking and financial services. She spent the first half of her
          career at DBS Bank, running marketing campaigns for the consumer banking group. She has extensive experience
          in planning and executing campaigns across various products and services with a proven track record of
          delivering results. Shefali graduated with distinction from McGill University in Canada with a Bachelor of
          Arts in Economics and Finance.</p>
      </div>
    </div>

    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/Vineet.png"
          alt="SingX Founder - Vineet Nagrani - International Payments and Exchange">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">Vineet Nagrani- Founder</h3>
        <p class="mt-h">Vineet has almost 30 years of experience as an Investment Banker, having worked in New York, Tokyo, Hong
          Kong, Mumbai and Singapore. He has a Bachelor’s degree from Indian Institute of Technology - Kanpur and an MBA
          from University of California – Berkeley.</p>
      </div>
    </div>

    <div class="row" style="height: 90px;"></div>

    <div class="row">
      <div class="col-md-4">
        <img class="imgPic" src="https://singx-static.s3.ap-southeast-1.amazonaws.com/images/team/Kula.png" 
        alt="SingX Founder - Kula Kulendaran - International Payments">
      </div>
      <div class="col-md-8">
        <h3 class="mt teams">Kula Kulendaran- Founder</h3>
        <p class="mt-h">Kula brings with him almost 30 years of experience in the financial services and payments arena with American
          Express, and in the FMCG industry with Nestlé. As Executive Vice President and Head of Global Network Services
          for American Express in Japan Asia Pacific & Australia, he demonstrated his natural ability to lead and
          inspire his staff. During his time there, he transformed the business and successfully grew market share in
          countries like China, Japan, Korea and Australia. Kula has an MBA from London Business School.</p>
      </div>
    </div>

    <div class="row" style="height: 90px;"></div>


  </div>
</section>

<!-- actual content end-->

<app-footer></app-footer>